import React from "react";

const FAQS = [
  { q: "Is CAREMatch a replacement for A&E?", a: "No. CAREMatch is not for medical emergencies. Call 999 (UK) or go to A&E." },
  { q: "Who are the doctors?", a: "All doctors are verified against the GMC (or equivalent) register with valid professional indemnity." },
  { q: "How does the AI navigator work?", a: "It asks plain-English questions and suggests the right route to care. It never diagnoses." },
  { q: "What does a consultation cost?", a: "£50 for a general (GP) consultation, £70 for a specialist. Prices are shown before you book." },
  { q: "Can I get a prescription?", a: "Yes, where clinically appropriate. Your doctor decides based on the consultation." },
  { q: "Can I cancel?", a: "Yes. Cancel up to 24 hours before your appointment for a full refund." },
  { q: "Is my data secure?", a: "Yes. Encrypted at rest and in transit. Your Care Passport is yours; export or delete at any time." },
  { q: "Do I need to be in the UK?", a: "The platform is UK-focused. International expansion is on our roadmap." },
];

export default function FAQ() {
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl">
        <div className="cm-eyebrow mb-2">Help</div>
        <h1 className="cm-h2">Frequently asked questions.</h1>
        <div className="mt-8 space-y-3">
          {FAQS.map((f, i) => (
            <details key={i} className="cm-card" data-testid={`faq-${i}`}>
              <summary className="font-semibold text-[#1a2b4a] cursor-pointer">{f.q}</summary>
              <p className="mt-2 text-sm text-[#475569] leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
}
